import _Vue from "vue";
import { GetDiversityDataService } from "./DiversityDataService";

export function DiversityDataServicePlugin(
  Vue: any,
  options?: any
): void {
  Vue.prototype.$dataService = GetDiversityDataService({ traceId: (Vue.appInsights ? Vue.appInsights.context.telemetryTrace.traceID : null)});
}
